export const CART_ADD = "addtocart";
export const CART_REMOVE = "removefromcart";
export const INCREASE_CART_ITEM_QUANTITY = "increasequantity";
export const DECREASE_CART_ITEM_QUANTITY = "decreasequantity";
export const EMPTY_CART = "emptycart";
